import { render, staticRenderFns } from "./I18NDetailList.vue?vue&type=template&id=38f6c142&scoped=true"
import script from "./I18NDetailList.vue?vue&type=script&lang=js"
export * from "./I18NDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6c142",
  null
  
)

export default component.exports